<form class="container sign-container reset-password-container">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
	<section class="navbar-brand">
		<img src="../../assets/img/{{themeService.theme}}/{{themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo'}}.png" alt="Company Logo" width="125px" [ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
	</section>
	<!-- <div class="sign-account" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
	<section class="container" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<h1 class="serif-title">Your submission has been received for <br> <span>{{parentForm.value.email}}</span>.</h1>
		<div class="block-max-width">
			<p>If we have an account matching that email address, you will receive an email with a link to reset your password.</p>
			<div class="get-in-touch">
				<input type="submit" class="form-control btn btn-primary primary-default-btn resend-code" value="Resend">
				<input [routerLink]="['/log-in']" type="submit"
					   class="form-control btn btn-primary primary-default-btn back-login" value="Go To Log In">
				<!-- <div class="sign-account sign-account-mobile" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
			</div>
		</div>
		
	</section>
</form>
<app-footer></app-footer>